import React from 'react';

import './footer.scss'

const Footer = () => {


    return (
        <>
        <div className='home-footer'>
            <p>Copyright Paweł Pazderski 2022</p>
        </div>
        </>
    )
}


export default Footer;